<template>
    <el-card class="tags-card">
        <div slot="header" class="card-header">
            <span class="header-title">最热标签</span>
            <a @click="moreTags" class="view-more">查看全部</a>
        </div>

        <div class="tags-cloud">
            <span v-for="t in tags" :key="t.id" 
                  @click="tag(t.id)"
                  class="tag-pill"
                  :style="getTagStyle(t)">
                {{t.tagName}}
            </span>
        </div>
    </el-card>
</template>
<script>
    export default {
        name: "ArticleTag",
        props: {
            tags: []
        },
        data() {
            return {}
        },
        methods: {
            moreTags() {
                this.$router.push('/tag/all');
            },
            tag(id) {
                this.$router.push({path: `/tag/${id}`});
            },
            getTagStyle(tag) {
                // 根据文章数量动态调整标签大小
                const count = tag.articleCount || 1;
                const sizes = [
                    { min: 0, size: '12px', padding: '5px 10px' },
                    { min: 5, size: '13px', padding: '6px 12px' },
                    { min: 15, size: '14px', padding: '7px 14px' }
                ];
                const style = sizes.find(s => count >= s.min) || sizes[0];
                return {
                    fontSize: style.size,
                    padding: style.padding
                };
            }
        }
    }
</script>

<style scoped>
    /* 标签卡片 */
    .tags-card :deep(.el-card__header) {
        padding: 20px 24px;
        border-bottom: none;
    }

    .tags-card :deep(.el-card__body) {
        padding: 0 24px 20px !important;
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .header-title {
        font-size: 15px;
        font-weight: 600;
        color: var(--text-primary);
        letter-spacing: 0.3px;
    }

    .view-more {
        font-size: 12px;
        color: var(--text-tertiary);
        cursor: pointer;
        transition: color 0.2s ease;
    }

    .view-more:hover {
        color: var(--accent-warm);
    }

    /* 标签云 */
    .tags-cloud {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .tag-pill {
        display: inline-flex;
        align-items: center;
        background: var(--bg-secondary);
        color: var(--text-secondary);
        border-radius: 20px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .tag-pill:hover {
        background: var(--accent-warm);
        color: white;
        transform: translateY(-1px);
    }
</style>
